import "./Features.module.css";
import Header from "@/reusable_sections/Header";
import FeaturesHero from "./sections/FeaturesHero";
import FeaturesGrid from "./sections/FeaturesGrid";
import SecurityBusinessCta from "./sections/SecurityBusinessCta";
import DifferentiateCompany from "./sections/DifferentiateCompany";
import SuccessPathFormHome from "./sections/SuccessPathFormHome";
import Footer from "@/reusable_sections/Footer";
export default function FeaturesPage() {
  return <div>
      <Header />
      <FeaturesHero />
      <FeaturesGrid />
      <SecurityBusinessCta />
      <DifferentiateCompany />
      <SuccessPathFormHome />
      <Footer />
    </div>;
}